import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Subject} from "rxjs";
import {HubConnection} from "@microsoft/signalr";
import {buildHubConnection, startHubConnection, stopHubConnection} from '../_helpers/hub-connection.helper';
import {HubState} from '../_models/hub-state';
import {OrdSpedBox} from "../_models/OrdSpedBox";
import {OrganizzazioniService} from "./organizzazioni.service";
import {SaveMessage} from "../_helpers/save-message";

@Injectable({providedIn: 'root'})
export class OrdiniSpedizioneBoxService {

  public lastOrdSpedBoxLaunched: Subject<OrdSpedBox> = new Subject<OrdSpedBox>();
  public lastOrdSpedBoxCreated: BehaviorSubject<OrdSpedBox> = new BehaviorSubject<OrdSpedBox>(null);
  public lastOrdSpedBoxUpdated: BehaviorSubject<OrdSpedBox> = new BehaviorSubject<OrdSpedBox>(null);
  public lastOrdSpedBoxDeleted: BehaviorSubject<OrdSpedBox> = new BehaviorSubject<OrdSpedBox>(null);
  public hubState: BehaviorSubject<number> = new BehaviorSubject<number>(HubState.Connecting);
  private hubConnection: HubConnection;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage) {}

  public startConnection() {
    this.hubConnection = buildHubConnection(`${environment.localApiUrl}hubs/ordinispedizionibox`, this.hubState);

    this.hubConnection.on('SendCreated', (box: OrdSpedBox) => {
      if (box.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        const rifOdS = this.getRifOdS(box);
        const message = rifOdS
          ? `Nuovo collo creato sull'ordine ${rifOdS}.`
          : 'Nuovo collo creato.';
        this.saveMessage.messageInfo(message);
        this.lastOrdSpedBoxCreated.next(box);
      }
    });

    this.hubConnection.on('SendUpdated', (box: OrdSpedBox) => {
      if (box.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        const rifOdS = this.getRifOdS(box);
        const message = rifOdS
          ? `Collo aggiornato sull'ordine ${rifOdS}.`
          : 'Collo aggiornato.';
        this.saveMessage.messageInfo(message);
        this.lastOrdSpedBoxUpdated.next(box);
      }
    });

    this.hubConnection.on('SendDeleted', (box: OrdSpedBox) => {
      if (box.organizzazioneId === this.organizzazioniService.organizzazioneId) {
        const rifOdS = this.getRifOdS(box);
        const message = rifOdS
          ? `Collo eliminato sull'ordine ${rifOdS}.`
          : 'Collo eliminato.';
        this.saveMessage.messageInfo(message);
        this.lastOrdSpedBoxDeleted.next(box);
      }
    });

    return startHubConnection(this.hubConnection, this.hubState);
  }

  public stopConnection() {
    void stopHubConnection(this.hubConnection);
  }

  private getRifOdS(box: OrdSpedBox): string | null {
    if (!box?.idDocumento || box.idDocumento <= 0) {
      return null;
    }
    if (box.idRiga > 0) {
      return `${box.idDocumento}.${box.idRiga}`;
    }
    return `${box.idDocumento}`;
  }
}
